/**
 * Redux actions for media
 * @module services/media/redux/actions
 */

export const DELETE_MEDIA = 'DELETE_MEDIA'

export const deleteMedia = ({ storeKey, mediaId }) => {
  if (!mediaId) {
    throw new Error('The mediaId parameter is required')
  }

  return {
    type: DELETE_MEDIA,
    payload: { storeKey, mediaId },
  }
}
